import React from 'react';
import { CHURCH_INFO } from '../config/constants';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <h1 className="hero-title">
          Welcome to {CHURCH_INFO.name}
        </h1>
        <p className="hero-subtitle">
          Join us in worship, fellowship, and growing closer to God
        </p>
      </div>
    </section>
  );
};

export default HeroSection;